import React from "react";
import { Group, Circle, Text, Line } from "react-konva";
import { scoreValues } from "../../../../../../API/config";
import BrandColors from "../../../../../../styles/BrandColors";

const ScoreIndicator = (props) => {
  const { x, y, score, label, validityDate, expired } = props;

  const { JLLBrandColors } = BrandColors;
  const { ComponentColors } = JLLBrandColors;

  let scoreColor = ComponentColors.ScoreIndicators.noScore;
  if (score === scoreValues.blocked) {
    scoreColor = ComponentColors.ScoreIndicators.block;
  } else if (score === scoreValues.high) {
    scoreColor = ComponentColors.ScoreIndicators.high;
  } else if (score === scoreValues.medium) {
    scoreColor = ComponentColors.ScoreIndicators.medium;
  } else if (score === scoreValues.low) {
    scoreColor = ComponentColors.ScoreIndicators.low;
  }

  const cp1 = 225 * (Math.PI / 180);
  const cp2 = 45 * (Math.PI / 180);
  const cp3 = 315 * (Math.PI / 180);
  const cp4 = 135 * (Math.PI / 180);

  const l1x1 = x + 10 * Math.cos(cp1);
  const l1y1 = y + 10 * Math.sin(cp1);
  const l1x2 = x + 10 * Math.cos(cp2);
  const l1y2 = y + 10 * Math.sin(cp2);
  const l2x1 = x + 10 * Math.cos(cp3);
  const l2y1 = y + 10 * Math.sin(cp3);
  const l2x2 = x + 10 * Math.cos(cp4);
  const l2y2 = y + 10 * Math.sin(cp4);

  return (
    <Group>
      <Circle radius={10} fill={scoreColor} x={x} y={y} />
      {expired && (
        <Line
          points={[l1x1, l1y1, l1x2, l1y2]}
          fill={"white"}
          stroke={"white"}
          tension={0.0}
          strokeWidth={2}
          rotate={"45"}
        ></Line>
      )}
      {expired && (
        <Line
          points={[l2x1, l2y1, l2x2, l2y2]}
          fill={"white"}
          stroke={"white"}
          tension={0.0}
          strokeWidth={2}
          rotate={"45"}
        ></Line>
      )}
      <Text
        text={label}
        wrap="none"
        align="left"
        x={x - 10}
        y={y + 20}
        fontSize={10}
      />
      <Text
        text={validityDate}
        wrap="none"
        align="left"
        x={x - 10}
        y={y + 35}
        fontSize={10}
      />
    </Group>
  );
};

export default ScoreIndicator;
